module.exports = __webpack_public_path__ + "static/img/try.dcde3c66.png";